import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import { useParams, Link } from "react-router-dom"

const SupplierDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["user-detail", id], `user/${id}`)

  if (isLoading) {
    return <div>Loading...</div>
  }

  const user = response?.data

  return (
    <div>
      <div className="breadcrumb-card">
        <h5>User Details</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/pos/dashboard">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/pos/users">Users</Link>
          </li>
          <li>{user?.name}</li>
        </ul>
      </div>
      {user ? (
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 xxl:tw-grid-cols-5 tw-gap-6">
          <div className="card bg-white border-0 px-4 rounded-3 mb-4 lg:col-span-3 xxl:col-span-4">
            <p className="my-5 text-base font-semibold text-black">
              Assigned Branches
            </p>
            {user.branches?.length ? (
              <div className="flex flex-wrap gap-3 pb-5">
                {user.branches.map((branch) => (
                  <div
                    key={branch.id}
                    className="rounded-lg border border-gray-200 px-4 py-3 min-w-40"
                  >
                    <p className="font-medium text-black mb-1">{branch.name}</p>
                    <span className="text-sm text-gray-600">{branch.code}</span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-600 pb-5">
                This user has not been assigned to a branch.
              </p>
            )}
          </div>
          <div className="card bg-white border-0 ps-5 rounded-3 mb-4">
            <div className="card-body p-4">
              <div className="flex align-items-center mb-3 mb-lg-4">
                <div className="flex align-items-center">
                  <DetailAvatar name={user.name} />
                </div>
              </div>

              <div className="mb-3">
                <p>Phone:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {user.phone ? user.phone : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Email:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {user.email ? user.email : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Email Verified At:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {user.email_verified_at
                    ? user.email_verified_at
                    : "Not Verified"}
                </span>
              </div>

              <div className="mb-3">
                <p>Last Login:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {user.last_login ? user.last_login : "N/A"}
                </span>
              </div>
              <div className="mb-3">
                <p>Roles:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {user.roles?.length
                    ? user.roles.join(", ")
                    : "No role assigned"}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No User data found.</div>
      )}
    </div>
  )
}
export default SupplierDetails
